export const videoMimeType =
  'video/x-msvideo, video/mp4, video/mpeg, video/ogg, video/mp2t, video/3gpp, video/3gpp2, video/webm';
